var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "63px",
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-describedby": "defects-title defects-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "defects-title"
  }, "Defects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "defects-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "defects-desc"
  }, "A slightly broken product")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLY_IconFamily_v2-copy",
    transform: "translate(-359.000000, -187.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(360.728100, 188.646150)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-130",
    points: "33.677 18.24075 45.575 30.13875 28.478 47.23675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6091,14.17825 L25.8311,10.40025 C23.4511,8.02125 23.4511,4.16325 25.8311,1.78425 C28.2101,-0.59475 32.0671,-0.59475 34.4471,1.78425 C36.8261,4.16325 36.8261,8.02125 34.4471,10.40025 L30.6691,14.17825 C30.3761,14.47025 29.9011,14.47025 29.6091,14.17825 Z",
    id: "Stroke-131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6687,46.09915 L34.4467,49.87715 C36.8267,52.25715 36.8267,56.11415 34.4467,58.49415 C32.0677,60.87215 28.2107,60.87215 25.8307,58.49415 C23.4517,56.11415 23.4517,52.25715 25.8307,49.87715 L29.6087,46.09915 C29.9017,45.80715 30.3767,45.80715 30.6687,46.09915 Z",
    id: "Stroke-132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0994,29.60895 L49.8774,25.83095 C52.2574,23.45195 56.1144,23.45195 58.4934,25.83095 L58.4944,25.83095 C60.8724,28.20995 60.8724,32.06695 58.4944,34.44695 L58.4934,34.44695 C56.1144,36.82595 52.2574,36.82595 49.8774,34.44695 L46.0994,30.66895 C45.8074,30.37595 45.8074,29.90095 46.0994,29.60895 Z",
    id: "Stroke-133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1785,30.66845 L10.4005,34.44645 C8.0205,36.82645 4.1635,36.82645 1.7845,34.44645 L1.7835,34.44645 C-0.5945,32.06745 -0.5945,28.21045 1.7835,25.83045 L1.7845,25.83045 C4.1635,23.45145 8.0205,23.45145 10.4005,25.83045 L14.1785,29.60845 C14.4705,29.90145 14.4705,30.37645 14.1785,30.66845 Z",
    id: "Stroke-134"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-135",
    points: "26.6345 42.07085 14.7025 30.13885 31.8715 12.96985"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefects);
export default __webpack_public_path__ + "static/media/defects.aa8ec4b422d9deb03260fa56dfd7a4d1.svg";
export { ForwardRef as ReactComponent };